import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Fee from '../../entities/casis/fee'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface FeeState extends ListState<Fee>{
    editModel:Fee;
    activeList: Array<Fee>;    
}
class FeeModule extends ListModule<FeeState,any,Fee>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<Fee>(),
        loading:false,
        editModel: new Fee(),
        activeList: new Array<Fee>(),
        path: 'fees'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
        async getAll(context: ActionContext<FeeState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/' + (context.state as any).path, { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            context.state.totalCount = reponse.data.result.length;
            context.state.list = reponse.data.result.list;
            context.state.activeList = reponse.data.result.fees;
        },
        async create(context: ActionContext<FeeState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.post('/api/' + (context.state as any).path, payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            return response.data.result;
        },
        async updateBatch(context: ActionContext<FeeState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.put('/api/fees-batch', payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
        },
        async export(context: ActionContext<FeeState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/fees/export', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            return reponse.data.result.filename;
        },
        async enable(context: ActionContext<FeeState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.post('/api/fees/enable', payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
        },
        async confirm(context: ActionContext<FeeState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.post('/api/fees/confirm', payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
        },
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
        edit(state: FeeState, model: Fee) {
            state.editModel = model;
            
        }, 
        new(state: FeeState, model: Fee) {
            state.editModel = Object.assign({});
        },
    });
}
const feeModule=new FeeModule();
export default feeModule;
